export default {
	type: 'string',
}
